import { AirlineViewModel } from '@bhtp-client-web/component';

export class Airline extends AirlineViewModel { }


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/airline.model.ts